module.exports = function() {
  return new Worker("/" + "assets/3rdparty/Decoder.worker.1eacb888accc92d4ae3c.js");
};